module.exports = __webpack_public_path__ + "img/pro-m-slider22.10bf6d2a.png";